import React from 'react'
import { Wrapper, BarStrip, ProgressBar } from '../_components'
import Table, { SelectColumnFilter } from '../_components/Table'
import data from '../fixtures'
import Axios from 'axios'
import moment from 'moment'


const StatusFieldCol = record => {
  return (
    <div className="flex items-center justify-center rounded bg-red-500 text-white text-xs py-1">
      {`${record.value}`}
    </div>
  )
}

const ActionField = ( record ) => {
  return (
    <div onClick={() => alert( record.value )} className="cursor-pointer w-auto md:w-20 lg:w-24 py-1 rounded-sm bg-[#AFC836] text-xs text-gray-700 flex items-center justify-center">
      {`View`}
    </div>
  )
}

export default function AllRegistration( { product } ) {
  const RegistrationColumns = React.useMemo( () => 
  [
    {
      Header: "#",
      accessor: "recordId"
    },
    {
      Header: "S.No",
      accessor: "sno"
    },
    {
      Header: "Name of Organisation/Applicant",
      accessor: "applicant"
    },
    {
      Header: "Username",
      accessor: "username"
    },
    {
      Header: "Region",
      accessor: "region"
    },
    {
      Header: "District",
      accessor: "district"
    },
    {
      Header: "Date of Registration",
      accessor: "date"
    },
    {
      Header: "Current Stage",
      accessor: "current_status",
      Cell: StatusFieldCol
    },
    {
      Header: "Action",
      accessor: "id",
      Cell: ActionField
    },

  ] )
  
  const [ records, setRecords ] = React.useState( [] )
  const [ loading, setLoading ] = React.useState( true )

  React.useEffect( () => {
    if( loading ) {
      fetchAllUsers()
    }
  },[ loading ] )

  const fetchAllUsers = async () => {
    try {
      const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcouser` ) 
      if( response.data ) {
       const results = response.data.records
          .filter( user => user.user_role !== "ADMIN" )
          .map( ( result, index ) => {
        return {
          id: result.id,
          recordId: `${index+1}`,
          applicant: result.applicant || "Test Uganda Ltd",
          username: result.username,
          region: result.region || "Central",
          district: result.district || "Kampala",
          date: moment( result.created_at ).format( "DD MMM, YYYY" ),
          current_status: result.status
        }
       } )
       setRecords( results )
       setLoading( false )
      }
    } catch (error) {
      alert( "Server error occured." )
      setLoading( false )
    }
  }

  return (
    <Wrapper>
        <div className="flex flex-col h-full">
          <BarStrip />
          <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
            <div className="px-5 py-2 text-sm bg-white">
              {`Registration Details of IT Service Providers`}
            </div>
            <div className="flex w-full bg-white">
              <Table 
                rightButton={false}
                rightBtnCallback={ () => {}}
                rightButtonLabel={null}
                label="Registration"
                columns={RegistrationColumns}
                data={records}
                hidePagination={false}
                exportToExcel={() => {}}
                exportToCSV={() => {}}
              />
            </div>
          </div>
        </div>
    </Wrapper>
  )
}
